export const CDN_BASE_URL = 'https://cdn.shengjianyou.com/website-img'; // 替换为实际的CDN域名

export const IMG_PATHS = {
  LOGO: `${CDN_BASE_URL}/logo2.png`,
  BACKGROUND: `${CDN_BASE_URL}/background.png`,
  BG_JPG: `${CDN_BASE_URL}/bg.jpg`,
  WAIT_PLEASE: `${CDN_BASE_URL}/waitplease.png`,
  ICON: `${CDN_BASE_URL}/icon.png`,
  TERMINATE1: `${CDN_BASE_URL}/terminate1.jpg`,
  TERMINATE2: `${CDN_BASE_URL}/terminate2.jpg`,
  TERMINATE3: `${CDN_BASE_URL}/terminate3.jpg`,
  TERMINATE4: `${CDN_BASE_URL}/terminate4.jpg`,
};